import { SetupPage, TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { BrandIq } from '../../../brandiq.setup';

const parent: SetupPage = BrandIq.pages.brandiqBasic;
const path = 'app-insights';
const title = 'PAGE.BRANDIQ.BRANDIQ_BASIC.APP_INSIGHTS.TITLE';
const res = [];

export const BrandIqAppInsightsTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
